// extracted by mini-css-extract-plugin
export default {"pattern":"_3TlMWQOU"};